<rw-modal
  modalId="addUserModal"
  datapendoid="add-user-modal"
  datatestid="add-user-modal"
  [title]="'Add User'"
  [arialabel]="'Add User'"
  [dismissible]="false"
  size="lg"
  #modalRef
>
  <div modal-body class="extended-margin">
    @if (isActive && mainForm) {
      <div class="custom-header">
        <div class="header-row">
          <div class="step-title" [innerHTML]="getTitle()"></div>
          <div class="floatingCart">
            <app-shopping-cart-icon [cartClass]="'userCart'" (ToggleShoppingCart)="toggleShoppingCart()">
            </app-shopping-cart-icon>
          </div>
        </div>
        <div class="step-desc" [innerHTML]="getDescription()"></div>
      </div>
      @if (isShoppingCartVisible) {
        <app-shopping-cart
          [PaymentInfo]="paymentInfo"
          [IsInline]="false"
          (CloseCart)="toggleShoppingCart()"
        ></app-shopping-cart>
      }
      <form [formGroup]="mainForm">
            <app-new-user-details
              [userDetailsForm]="mainForm?.get('UserCreate')"
              [hasAccountOwner]="hasAccountOwner"
              [data]="addUserData"
              (pendingValidationEvent)="pendingValidationChanged($event)"
              [hidden]="getStepID() !== 'USER'"
              />
            <app-change-package
              [packageSelectForm]="mainForm?.get('UserPackage')"
              [OrganizationID]="OrganizationID"
              [orgProfile]="orgProfile"
              [orgConfig]="orgConfig"
              [orgWlpContactInfo]="orgWlpContactInfo"
              [AllActions]="AllActions"
              (PackageSelected)="packageSelected($event)"
              (PackagesLoaded)="packagesLoaded($event)"
              (AddonsLoaded)="addonsLoaded($event)"
              [CheckForInitialActiveMessage]="checkForInitialActiveMessage"
              [hidden]="getStepID() !== 'PKG'"
              />
            <app-manage-addons
              [addonsSelectForm]="mainForm?.get('UserAddons')"
              [OrganizationID]="OrganizationID"
              [orgProfile]="orgProfile"
              [orgConfig]="orgConfig"
              [orgWlpContactInfo]="orgWlpContactInfo"
              [SelectedPackage]="selectedPackage"
              [AddOnList]="availableAddOns"
              [hidden]="getStepID() !== 'ADDON'"
              />
            <app-deploy-quickbooks
              [licenseSelectForm]="mainForm?.get('UserLicense')"
              [OrganizationID]="OrganizationID"
              (noLicenseEvent)="noLicenseEvent($event)"
              (licensesEvent)="licensesEvent($event)"
              (pendingLicenseCheckEvent)="pendingLicenseCheckEvent($event)"
              (selectedLicenseEvent)="selectedLicenseEvent($event)"
              [hidden]="getStepID() !== 'LICENSE'"
              />
            <app-review-user
              [reviewForm]="mainForm"
              [paymentInfo]="paymentInfo"
              (promoEvent)="promoEvent($event)"
              [hidden]="getStepID() !== 'REVIEW'"
            />
      </form>
    }
  </div>
  <div modal-footer>
    @if (isActive && mainForm) {
      <app-button
        id="btnCancel"
        label="CANCEL"
        buttonStyle="addUserTeritary"
        noContentPadding="true"
        (clickActionEmitter)="cancelAddUser()"
      >
      </app-button>
      @if (addUserSteps.activeIndex > 0) {
        <app-button
          id="btnPrevious"
          label="BACK"
          buttonStyle="addUserBack"
          noContentPadding="true"
          (clickActionEmitter)="handlePrevious()"
        >
        </app-button>
      }
      <app-button
        id="btnNext"
        [label]="getButtonText()"
        [disabled]="!canNavigateToNextStep()"
        noContentPadding="true"
        buttonStyle="primary"
        (clickActionEmitter)="handleNext()"
      >
      </app-button>
    }
  </div>
</rw-modal>
